
















import Vue from "vue";
import { mapState } from "vuex";
import GoalFilter from "../components/assignments/goal-filter.vue";
import TrackingFilter from "../components/goals/tracking-filter.vue";
import ReportCard from "../components/goals/report-card.vue";

export default Vue.extend({
  components: {
    GoalFilter,
    ReportCard,
    TrackingFilter
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("goal", ["loading", "currentGoal"]),
    goalForAssignmentsAndReport() {
      let currentGoal = (this as any).currentGoal;
      return currentGoal && {}.toString.call(currentGoal) === "[object Function]" ? null : currentGoal;
    }
  },
  methods: {
    handleFilter(filter) {
      (this as any).$refs.ReportCard.refreshReportData();
    }
  }
});
